import React from "react";
import "./sponsorship.component.css";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import smartvenue from "../../assets/images/smartvenue.jpg";


const SmartVenue = () => {

    return (
        <>
            <Helmet>
                <title>ABOUT US SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
                <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <HeaderComponent />
            <NavbarComponent />
            <section id="fixed-sub-nav" className="gradient-background" style={{ paddingBottom: '30px', paddingTop: '30px' }}>
                <div className="container pt-4">
                    <div className="row g-4 mt-3" style={{ fontSize: '16px' }}>
                        {/* Left Side - Venue Details */}
                        <div className="col-12 col-md-6 d-flex">
                        <div className="card p-4 w-100 h-100 shadow-card">
                            <h4 className="mb-3 text-primary fw-bold">Venue Details</h4>
                            <img
                            src={smartvenue}
                            alt="Venue"
                            className="img-fluid rounded mb-3"
                            />
                            <p className="mb-1"><strong>Hotel Name:</strong> Grand Mercure Bengaluru at Gopalan Mall</p>
                            <p className="mb-1"><strong>Address:</strong> Old Madras Rd, Rahat Bagh, Nagavarapalya, Bengaluru, Karnataka 560093</p>
                            <p className="mb-3"><strong>Date & Time:</strong> May 11, 2025 - 08:30 AM</p>
                            <div className="bg-light p-3 rounded">
                            <p className="mb-1"><strong>For Queries:</strong></p>
                            <p className="mb-0">📞 +91-9880107412</p>
                            </div>
                        </div>
                        </div>

                        {/* Right Side - Map */}
                        <div className="col-12 col-md-6 d-flex">
                        <div className="card p-4 w-100 h-100 shadow-card">
                            <h4 className="mb-3 text-primary fw-bold">Location Map</h4>
                            <div className="ratio ratio-4x3">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.678715977011!2d77.66002043988932!3d12.992389514289776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae114af0627a73%3A0xc7b915837770cbef!2sGrand%20Mercure%20Bengaluru%20at%20Gopalan%20Mall!5e0!3m2!1sen!2sin!4v1746595124671!5m2!1sen!2sin" 
                                    width="600" 
                                    height="500" 
                                    style={{border:'0'}} 
                                    allowfullscreen="" 
                                    loading="lazy" 
                                    referrerpolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </section>
            <FooterComponent />
        </>
    );
};

export default SmartVenue;
